export const BREAKPOINT_SMALL: number = 468
export const BREAKPOINT_SMALLEST_CHROME_WINDOW: number = 501
export const BREAKPOINT_MEDIUM: number = 768
export const BREAKPOINT_LARGE: number = 1152

type Breakpoints = {
  small: number
  smallestChromeWindow: number
  medium: number
  large: number
}

const breakpoints: Breakpoints = {
  small: BREAKPOINT_SMALL,
  smallestChromeWindow: BREAKPOINT_SMALLEST_CHROME_WINDOW,
  medium: BREAKPOINT_MEDIUM,
  large: BREAKPOINT_LARGE,
}

export default breakpoints
